import React, {forwardRef} from 'react'
import PropTypes from 'prop-types'

const Video = forwardRef(({src, preload = 'metadata', ...props}, ref) => {
    return (
        <video 
            autoPlay 
            muted 
            loop 
            width="100%" 
            height="auto" 
            playsInline 
            preload={preload}
            {...props}
            ref={ref}
        >
            <source src={src} type="video/mp4" />
        </video>
    )
})

Video.propTypes = {
    src: PropTypes.string,
    preload: PropTypes.oneOf(['none', 'metadata', 'auto'])
    // `ref` is handled by forwardRef and must not be declared as a propType —
    // validating it makes React read props.ref and emit "ref is not a prop".
}

Video.displayName = 'Video'

export default Video
